// Single seam for post-login routing by role. W1: team users (owner/member)
// and no-team users all land on /library. W2 will add an admin branch
// (`if (me.isAdmin) return '/admin'`); W3 will swap /library → /dashboard.
export function roleHome(me: { isAdmin?: boolean; teams: Array<{ role: string }> }): string {
  if (me.isAdmin) return '/admin';
  return '/library';
}
